import CrossIcon from '../icons/CrossIcon';
import CurrentLocationComponent from '../../components/CurrentLocation';
import CustomSearchIcon from '../../components/icons/SearchIcon';
import LocationAutocompleteComponent from '../../components/autocomplete/LocationAutocomplete';
import { BodyGrey, BodyLarge } from '../../components/Typography';
import { Box, styled } from '@mui/material';
import { fontWeight } from '../../theme/typography';
import { HFlex, VFlex } from '../FlexContainers';
import { palette } from '../../theme/palette';

export const Menu = styled(Box)`
  width: 100%;
  height: fit-content;
  padding: 0px 20px 20px 20px;
  transition: all 2s ease-in;
  background: ${palette.custom.white};
`;

export const TopBar = styled(HFlex)`
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 15px;
`;

export const LocationAutocomplete = styled(LocationAutocompleteComponent)`
  border-radius: 5px;
  border: 1px solid ${palette.custom.grey};
  .autocomplete-dropdown {
    padding: 0 10px 0 10px;
  }
  .autocomplete-dropdown-item {
    padding: 0;
    transition: padding 0.4s ease-in-out;
  }
  .autocomplete-dropdown-item:hover {
    padding: 0 10px 0 10px;
    transition: padding 0.4s ease-in-out;
  }
`;

export const CurrentLocationWrapper = styled(VFlex)`
  width: 100%;
  justify-content: center;
  align-items: center;
`;

export const CurrentLocation = styled(CurrentLocationComponent)`
  border-radius: 5px;
  border: 1px solid ${palette.primary.main};
  background: ${palette.custom.white};
  height: 40px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 220px;
  color: ${palette.custom.darkGrey};
  text-transform: math-auto;
`;

export const LocationLabel = styled(BodyLarge)`
  font-weight: ${fontWeight.bold};
  margin-bottom: 0px;
`;

export const HelperText = styled(BodyGrey, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<{
  hasError?: boolean;
}>`
  color: ${(props) => (props.hasError ? palette.error.main : palette.custom.mediumGrey)};
  margin-top: 4px;
  margin-left: 2px;
  margin-bottom: 10px;
`;

export const SearchIcon = styled(CustomSearchIcon)`
  color: ${palette.custom.mediumGrey};
  width: 16px;
`;

export const CloseButton = styled(Box)`
  cursor: pointer;
  color: ${palette.primary.main};
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CloseIcon = styled(CrossIcon)`
  color: ${palette.custom.grey};
  width: 21px;
  height: 21px;
  object-fit: contain;
`;
